import React from 'react';
import _ from 'lodash';

/**
 * Wrapper input to support placeholder text for react table's input filter
 * supports a defined prop "filterPlaceholderText" for a column
 * defaults to "Filter"
 */
export function PlaceholderInput({ filter, onChange, column, ...props }) {
  return (
    <input
      type="text"
      placeholder={_.get(column, 'filterPlaceholderText', 'Filter')}
      value={filter ? filter.value : ''}
      onChange={event => onChange(event.target.value)}
      {...props}
    />
  );
}



// WEBPACK FOOTER //
// ./src/common/Components/ReactTableWrapper/PlaceholderInput.js